module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.3f760f71.woff";